(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elturco-kit-choice"] && !Shopify.designMode) return;
  try {
    (() => {
    let observer;
    function watchKitPicker() {
      if (observer) observer.disconnect();
      const helper = document.querySelector('.js-product .elturco-kit-choice');
      const picker = helper?.closest('.js-product')?.querySelector('variant-picker');
      document.body.classList.remove('elturco-kit-picking');
      if (!picker || !('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver((entries) => {
        document.body.classList.toggle('elturco-kit-picking', entries.some((entry) => entry.isIntersecting));
      });
      observer.observe(picker);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchKitPicker, { once: true });
    } else {
      watchKitPicker();
    }
    document.addEventListener('on:variant:change', watchKitPicker);
  })();
  } catch(e) { console.error(e); }
})();

})();
